'use strict'
import DataTableHelper from '../common/DataTableHelper'

//  Fields
const FIELDS = {
  ORG_ID: 'orgId',
  ORG_NAME: 'nameOfficial',
  CONFERENCE_ID: 'conferenceId',
  CONFERENCE_NAME: 'conferenceName',
  DIVISION: 'division',
  SUBDIVISION: 'subdivision',
  RECLASS_DIVISION: 'reclassDivision',
  RECLASS_SUBDIVISION: 'reclassSubdivision',
  STATE: 'memberOrgAddress.state',
  WEBSITE: 'webSiteUrl',
  ATHLETIC_WEBSITE: 'athleticWebUrl',
  SPORT_CONFERENCE_ID: 'sportConferenceId',
  SPORT_CONFERENCE_NAME: 'sportConferenceName',
  SPORT_DESCRIPTION: 'sportDescription',
  SPORT_REGION: 'sportRegion',
  PRIVATE_FLAG: 'privateFlag',
  HBCU_FLAG: 'historicallyBlackFlag',
  MULTI_DIV_SPORT_CONF: 'multiDivSportConfFlag'
}

const ORG_NAME_COLUMN = {
  data: FIELDS.ORG_NAME,
  title: 'Name',
  render: function (data, type, row) {
    return renderOrgHyperlink(row[FIELDS.ORG_ID], row[FIELDS.ORG_NAME])
  }
}

const CONFERENCE_COLUMN = {
  data: FIELDS.CONFERENCE_NAME,
  title: 'Conference',
  render: function (data, type, row) {
    if (!row[FIELDS.CONFERENCE_NAME] || (row[FIELDS.CONFERENCE_NAME] && row[FIELDS.CONFERENCE_NAME].length === 0)) {
      return 'Independent'
    }
    return renderOrgHyperlink(row[FIELDS.CONFERENCE_ID], row[FIELDS.CONFERENCE_NAME])
  }
}

const DIVISION_COLUMN = {
  data: FIELDS.DIVISION,
  title: 'Division',
  render: function (data, type, row) {
    return DataTableHelper.renderDivisionSubdivisionText(row[FIELDS.DIVISION], row[FIELDS.SUBDIVISION])
  }
}

const DIVISION_CONF_COLUMN = {
  data: FIELDS.DIVISION,
  title: 'Division',
  render: function (data, type, row) {
    return DataTableHelper.renderConfDivisionSubdivisionText(row[FIELDS.DIVISION], row[FIELDS.SUBDIVISION], row[FIELDS.MULTI_DIV_SPORT_CONF])
  }
}

const DIVISION_ONLY_COLUMN = {
  data: FIELDS.DIVISION,
  title: 'Division',
  render: function (data, type, row) {
    return DataTableHelper.renderDivisionText(row[FIELDS.DIVISION])
  }
}

const RECLASS_DIVISION_COLUMN = {
  data: FIELDS.RECLASS_DIVISION,
  title: 'Reclass Division',
  render: function (data, type, row) {
    return DataTableHelper.renderDivisionSubdivisionText(row[FIELDS.RECLASS_DIVISION], row[FIELDS.RECLASS_SUBDIVISION])
  }
}

const STATE_COLUMN = {
  data: FIELDS.STATE,
  title: 'State'
}

const SPORT_COLUMN = {
  data: FIELDS.SPORT_DESCRIPTION,
  title: 'Sport'
}

const INSTITUTION_LINKS_COLUMN = {
  data: null,
  orderable: false,
  defaultContent: '',
  title: 'Links',
  render: function (data, type, row) {
    let hyperlinks = ''

    if (row[FIELDS.WEBSITE]) {
      hyperlinks += DataTableHelper.renderHyperlink(row[FIELDS.WEBSITE], 'glyphicons-education')
    }
    // Only show athletic websites for schools
    if (row[FIELDS.ATHLETIC_WEBSITE]) {
      if (hyperlinks.length > 0) hyperlinks += '<br/>'
      hyperlinks += DataTableHelper.renderHyperlink(row[FIELDS.ATHLETIC_WEBSITE], 'glyphicons-rugby')
    }
    return hyperlinks
  }
}

const NON_INSTITUTION_LINKS_COLUMN = {
  data: null,
  orderable: false,
  defaultContent: '',
  title: 'Links',
  render: function (data, type, row) {
    let hyperlinks = ''

    if (row[FIELDS.WEBSITE]) {
      hyperlinks += DataTableHelper.renderHyperlink(row[FIELDS.WEBSITE], null)
    }
    return hyperlinks
  }
}

const SPORT_CONFERENCE_COLUMN = {
  data: FIELDS.SPORT_CONFERENCE_NAME,
  title: 'Sport Conference',
  render: function (data, type, row) {
    if (!row[FIELDS.SPORT_CONFERENCE_NAME] || (row[FIELDS.SPORT_CONFERENCE_NAME] && row[FIELDS.SPORT_CONFERENCE_NAME].length === 0)) {
      return 'Independent'
    }
    return renderOrgHyperlink(row[FIELDS.SPORT_CONFERENCE_ID], row[FIELDS.SPORT_CONFERENCE_NAME])
  }
}

const SPORT_REGION_COLUMN = {
  data: FIELDS.SPORT_REGION,
  title: 'Region',
  render: function (data, type, row) {
    return DataTableHelper.renderInitCap(data)
  }
}

const PRIVATE_FLAG_COLUMN = {
  data: FIELDS.PRIVATE_FLAG,
  title: 'Public/Private',
  render: function (data, type, row) {
    return DataTableHelper.renderPrivateFlagText(row[FIELDS.PRIVATE_FLAG])
  }
}

const HBCU_FLAG_COLUMN = {
  data: FIELDS.HBCU_FLAG,
  title: 'HBCU',
  render: function (data, type, row) {
    return DataTableHelper.renderYesNoText(row[FIELDS.HBCU_FLAG])
  }
}

function defineColumns (typeId, sportCode) {
  let columns = []

  switch (typeId) {
    case 1:
    case 2:
    case 10:
    case 11:
      columns = [
        ORG_NAME_COLUMN,
        CONFERENCE_COLUMN,
        DIVISION_COLUMN,
        STATE_COLUMN,
        INSTITUTION_LINKS_COLUMN
      ]
      break
    case 3:
      columns = [
        ORG_NAME_COLUMN,
        DIVISION_CONF_COLUMN,
        NON_INSTITUTION_LINKS_COLUMN
      ]
      break
    case 4:
      columns = [
        ORG_NAME_COLUMN,
        NON_INSTITUTION_LINKS_COLUMN
      ]
      break
    case 5:
      columns = [
        ORG_NAME_COLUMN,
        CONFERENCE_COLUMN,
        DIVISION_COLUMN,
        RECLASS_DIVISION_COLUMN,
        STATE_COLUMN,
        INSTITUTION_LINKS_COLUMN
      ]
      break
    case 6:
    case 7:
    case 8:
    case 9:
      columns = [
        ORG_NAME_COLUMN,
        SPORT_CONFERENCE_COLUMN,
        SPORT_COLUMN
      ]
      break
    case 12:
      if (sportCode) {
        columns = [
          ORG_NAME_COLUMN,
          CONFERENCE_COLUMN,
          DIVISION_COLUMN,
          RECLASS_DIVISION_COLUMN,
          PRIVATE_FLAG_COLUMN,
          HBCU_FLAG_COLUMN,
          STATE_COLUMN,
          SPORT_REGION_COLUMN
        ]
      } else {
        columns = [
          ORG_NAME_COLUMN,
          CONFERENCE_COLUMN,
          DIVISION_COLUMN,
          RECLASS_DIVISION_COLUMN,
          PRIVATE_FLAG_COLUMN,
          HBCU_FLAG_COLUMN,
          STATE_COLUMN
        ]
      }
      break
    case 13:
    case 14:
    case 15:
      columns = [
        ORG_NAME_COLUMN,
        DIVISION_ONLY_COLUMN,
        STATE_COLUMN,
        NON_INSTITUTION_LINKS_COLUMN
      ]
      break
  }

  return columns
}

function defineOrder (typeId) {
  if (typeId >= 6 && typeId <= 9) {
    return [[2, 'asc'], [0, 'asc']]
  } else {
    return [[0, 'asc']]
  }
}

function renderOrgHyperlink (orgId, orgName) {
  if (orgId && orgName) {
    return '<a href="orgDetail?id=' + orgId + '">' + orgName + '</a>'
  } else {
    return ''
  }
}

export default {
  defineColumns: defineColumns,
  defineOrder: defineOrder,
  renderOrgHyperlink: renderOrgHyperlink
}
